/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontDetails_seller$ref = any;
type StorefrontFollowButton_seller$ref = any;
type StorefrontSocial_seller$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontHead_seller$ref: FragmentReference;
export type StorefrontHead_seller = {|
  +serviceId: ?string,
  +favoritesByUser?: ?$ReadOnlyArray<?{|
    +serviceId: ?string
  |}>,
  +sellerProfile: ?{|
    +company: ?string
  |},
  +storefrontProfile: ?{|
    +aboutUs: ?string,
    +photos: ?$ReadOnlyArray<?{|
      +path: ?string,
      +type: ?{|
        +name: ?string
      |},
    |}>,
  |},
  +$fragmentRefs: StorefrontFollowButton_seller$ref & StorefrontSocial_seller$ref & StorefrontDetails_seller$ref,
  +$refType: StorefrontHead_seller$ref,
|};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "serviceId",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "StorefrontHead_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    },
    {
      "kind": "RootArgument",
      "name": "storefrontId",
      "type": "Int"
    }
  ],
  "selections": [
    (v0/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "company",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "storefrontProfile",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "storefrontId",
          "variableName": "storefrontId",
          "type": "Int"
        }
      ],
      "concreteType": "StorefrontProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "aboutUs",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "photos",
          "storageKey": null,
          "args": null,
          "concreteType": "Photo",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "path",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "type",
              "storageKey": null,
              "args": null,
              "concreteType": "PhotoType",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontFollowButton_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontSocial_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontDetails_seller",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "favoritesByUser",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userIds",
              "variableName": "userId",
              "type": "String!"
            }
          ],
          "concreteType": "Favorite",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = '8410b4c5969fc0c58bc5ae655cf0bf67';
module.exports = node;
